<template>
  <div class="select-course-assistant-card">
    <div class="select-course-assistant-card-container">
      <div class="select-course-assistant-card-content">
        <div class="select-course-assistant-card-content-title">
          {{ title }}
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SelectCourseAssistantCard',
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  .select-course-assistant-card {

    &-container {
      width: 718px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-white;
      box-shadow: 0 10px 70px 0 #15b9bf;
      border-radius: 20px;
    }

    &-content {
      box-sizing: border-box;
      margin: -@size-small 0;
      padding: @size-large @size-medium;
      width: 686px;
      background: @color-white;
      box-shadow: 0 10px 70px 0 #15b9bf;
      border-radius: 18px;
    }

    &-content-title {
      margin-bottom: @size-medium;
      color: @color-text-base;
      font-size: @font-size-large;
      font-weight: @font-weight-bold;
      line-height: 1.5;
    }
  }

</style>
